(function () {
  function getVariants(wrapper) {
    var script = wrapper.querySelector('.ProductItem__QuickAddData');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSelects(wrapper) {
    return Array.prototype.slice
      .call(wrapper.querySelectorAll('.ProductItem__QuickAddOption'))
      .sort(function (a, b) {
        return a.dataset.optionPosition - b.dataset.optionPosition;
      });
  }

  function updateOptionAvailability(wrapper) {
    var variants = getVariants(wrapper);
    if (!variants) return;

    var selects = getSelects(wrapper);

    selects.forEach(function (targetSelect, targetIndex) {
      Array.prototype.slice.call(targetSelect.options).forEach(function (option) {
        if (option.value === '') return;

        var matches = variants.filter(function (variant) {
          return selects.every(function (select, i) {
            if (i === targetIndex) {
              return variant['option' + (i + 1)] === option.value;
            }

            if (!select.value) return true;

            return variant['option' + (i + 1)] === select.value;
          });
        });

        var hasAvailableMatch = matches.some(function (variant) {
          return variant.available;
        });

        option.disabled = matches.length > 0 && !hasAvailableMatch;
      });
    });
  }

  function openCartDrawer() {
    var trigger = document.querySelector(
      '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]'
    );

    if (trigger) {
      trigger.click();
      return;
    }

    document.dispatchEvent(
      new CustomEvent('cart:open', {
        bubbles: true,
      })
    );
  }

  function setLoading(button, isLoading) {
    if (isLoading) {
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding...';
      button.classList.add('is-loading');
      button.disabled = true;
    } else {
      button.textContent =
        button.dataset.originalText || button.textContent;

      button.classList.remove('is-loading');
      button.disabled = false;
    }
  }

  function addToCart(variantId, button, selects) {
    setLoading(button, true);

    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(
              (data && data.description) ||
                'That item is unavailable.'
            );
          });
        }

        return res.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );

        openCartDrawer();

        if (selects) {
          selects.forEach(function (select) {
            select.value = '';
          });
        }
      })
      .catch(function (err) {
        alert(
          err.message ||
            'Something went wrong adding to cart.'
        );
      })
      .finally(function () {
        setLoading(button, false);
      });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.ProductItem__QuickAddOption')) return;

    var wrapper = e.target.closest('.ProductItem__QuickAdd');
    if (!wrapper) return;

    updateOptionAvailability(wrapper);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.matches('.ProductItem__QuickAddConfirm')) return;
    if (e.target.disabled) return;

    var wrapper = e.target.closest('.ProductItem__QuickAdd');
    if (!wrapper) return;

    if (e.target.dataset.variantId) {
      addToCart(e.target.dataset.variantId, e.target);
      return;
    }

    var selects = getSelects(wrapper);

    var missingSelect = selects.find(function (select) {
      return !select.value;
    });

    if (missingSelect) {
      var optionName =
        missingSelect.dataset.optionName ||
        missingSelect.getAttribute('aria-label');

      if (optionName) {
        alert('Please select a ' + optionName.toLowerCase() + '.');
      } else {
        alert('Please select an option.');
      }

      return;
    }

    var variants = getVariants(wrapper);
    if (!variants) return;

    var match = variants.find(function (variant) {
      return selects.every(function (select, i) {
        return (
          variant['option' + (i + 1)] === select.value
        );
      });
    });

    if (!match || !match.available) {
      alert('That combination is sold out.');
      return;
    }

    addToCart(match.id, e.target, selects);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.ProductItem__QuickAdd')
      .forEach(updateOptionAvailability);
  });
})();